<style lang="scss">
// @import url("https://fonts.googleapis.com/css?family=Raleway:300,400,600");

// @import "node_modules/bulma/bulma.sass";
.services {
    width: 90%;
    margin: 0 auto;

       .table {
        width: 100%;

        .sorting {
            background-image: url('/images/sort_both.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_asc {
            background-image: url('/images/sort_asc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
        .sorting_desc {
            background-image: url('/images/sort_desc.png');
            background-repeat: no-repeat;
            background-position: center right;
        }
    }

}


h1 {
    text-align: center;
    font-size: 30px;
}
</style>

<template>
<div>
    <div class="row" v-if="$gate.isAdmin() || $gate.isAccount() || $gate.isManager() || $gate.isSupervisor()">
        <div class="row mb-2">
                <div class="col-md-4"></div>
                <div class="col-md-4 d-flex justify-content-center">
                    <img src="./../../Images/StepUp_logo.png" alt="StepUp" style="background-size: cover;width: auto; height: 150px;">
                </div>
                <div class="col-md-4"></div>
            </div>
            <div class="row">
                <div class="col-sm-1">
                    <input type="text" class="form-control" v-model="tableData.invoice" placeholder="Order#" @input="getServices()">
                </div>

                <div class="col-sm-3">
                    <input type="date" class="form-control" v-model="tableData.date" @input="getServices()">
                </div>

                <div class="col-sm-4">
                   <select v-model="tableData.customer" @change="getServices()" class="form-control">
                        <option  value="" disabled>Select Customer</option>
                        <option v-for="customer in customers" :key="customer.value" :value="customer.value"> {{customer.text}} </option>
                   </select>
                </div>

                <div class="col-md-3"></div>

                <div class="col-sm-1">
                    <select class="form-control" v-model="tableData.length" @change="getServices()">
                        <option v-for="(records, index) in perPage"
                        :key="index"
                        :value="records">{{records}}</option>
                    </select>
                </div>

                <div class="col-sm-12 mt-2">
                    <datatable :columns="columns"
                        :sortKey="sortKey"
                        :sortOrders="sortOrders"
                        @sort="sortBy">

                        <tbody>
                            <tr v-for="payment in payments" :key="payment.id">
                                <td>STEP - {{payment.id}}</td>
                                <td>{{payment.date}}</td>
                                <td>{{payment.notes}}</td>
                                <td>{{payment.name}}</td>
                                <td>{{payment.status}}</td>
                                <td>{{payment.total}}</td>
                                <td>{{payment.email}}</td>
                                <td>
                                    <options :items="payment">

                                    </options>
                                </td>

                            </tr>
                        </tbody>
                    </datatable>
                </div>

            </div>
            <div class="row">
                <div class="col-sm-3">
                    <pagination :pagination="pagination"
                        @prev="getServices(pagination.prevPageUrl)"
                        @next="getServices(pagination.nextPageUrl)">
                    </pagination>
                </div>
            </div>
    </div>
    <div class="row" v-else>
            <notfound></notfound>
    </div>
</div>
</template>

<script>
import html2pdf from 'html2pdf.js'
import Datatable from './../../datatable/Datatable.vue';
import Pagination from './../../datatable/Pagination.vue';
import PaymentOptions from './PaymentOptions.vue';

export default {
    components: {datatable: Datatable, pagination: Pagination, options:PaymentOptions},
    data() {
        let sortOrders = {};
        let columns = [
            {width: '10%', label: 'Order#', name: 'id'},
            {width: '10%', label: 'Date', name: 'date'},
            {width: '20%', label: 'Notes', name: 'notes'},
            {width: '20%', label: 'Name', name: 'name'},
            {width: '10%', label: 'Status', name: 'status'},
            {width: '10%', label: 'Total', name: 'total'},
            {width: '10%', label: 'Email', name: 'email'},
            {width: '10%', label: 'Action', name: 'action'},
        ];

        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            payments: [],
            columns: columns,
            sortKey: 'deadline',
            sortOrders: sortOrders,
            perPage: ['5', '10', '20', '30'],
            tableData: {
                draw: 0,
                length: 10,
                invoice: '',
                date: '',
                customer: '',
                column: 0,
                dir: 'desc',
                user_id: this.$root.id,
                name: this.$root.staffname,
            },
            pagination: {
                lastPage: '',
                currentPage: '',
                total: '',
                lastPageUrl: '',
                nextPageUrl: '',
                prevPageUrl: '',
                from: '',
                to: '',
            },
            customers: [],


        }
    },
    created(){
        this.getServices();
        this.getCustomers();
    },
    methods: {
        getServices(url = '/api/Report/Payment-Report'){
            this.tableData.draw++;
            axios
            .get(url, {params: this.tableData})
            .then(response => {
                let data = response.data;
                console.log(response);
                if(this.tableData.draw = data.draw) {
                    this.payments = data.data.data;
                    this.configPagination(data.data);
                }
            })
            .catch(errors => {
                console.log(errors);
            });
        },
        configPagination(data) {
            this.pagination.lastPage = data.last_page;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
        sortBy(key) {
            this.sortKey = key;
            this.sortOrders[key] = this.sortOrders[key] * -1;
            this.tableData.column = this.getIndex(this.columns, 'name', key);
            this.tableData.dir = this.sortOrders[key] === 1? 'asc' : 'desc';
            this.getServices();
        },
        getIndex(array, key, value) {
            return array.findIndex(i => i[key] == value)
        },
        getCustomers() {
            axios
            .get('./api/Report/Payment-Report/customers')
            .then((result) => {
                this.customers = result.data.customers
            }).catch((err) => {
                console.log(err)
            });
        },
        pdf() {
            var elements = document.getElementById('pdf')

            var opt = {
            margin: 15,
            filename: 'Product Report.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {scale: 1},
            jsPDF: {
              unit: 'mm',
            //   format: [280, 350],
              orientation: 'landscape'
            }
          }
          html2pdf().set(opt).from(elements).save()
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/Report/Report/Payment.vue